import {
    IntercompanyDecisionCodeRequest,
    IntercompanyDecisionCodeResult,
    IntercompanyPreviewGroup,
} from 'returnCenter-api';
import { orderAxiosInstance } from './api';

/**
 * Intercompany service - what the group companies that supplied MDC lines are owed.
 *
 * Uses the shared axios instance directly rather than a generated client method, because the
 * generated sources are regenerated from swagger and these endpoints are newer than the last
 * generation. Swap to returnApi once the client has been regenerated.
 */
export const intercompanyService = {
    /**
     * Reads each supplying company's MDC order to price what they are about to be credited.
     *
     * One ERP round-trip per supplying company, so call it when the operator opens the panel --
     * never as part of loading a return.
     */
    getPreview: async (returnId: number, language?: string): Promise<IntercompanyPreviewGroup[]> => {
        const response = await orderAxiosInstance.get<IntercompanyPreviewGroup[]>(
            `/api/return/${returnId}/intercompany/preview`,
            { params: language ? { language } : undefined },
        );
        return response.data;
    },

    /**
     * What the supplying companies would decide for rows being edited right now.
     *
     * Cheap by design: everything the rules key on travels in the request, so this switches company
     * and reads rules but touches no ERP. That is what lets it run on every reason-code change.
     */
    resolveDecisionCodes: async (
        request: IntercompanyDecisionCodeRequest,
    ): Promise<IntercompanyDecisionCodeResult[]> => {
        const response = await orderAxiosInstance.post<IntercompanyDecisionCodeResult[]>(
            '/api/return/intercompany/decision-codes',
            request,
        );
        return response.data;
    },
};
